import { createSlice } from "@reduxjs/toolkit";

const mantraAddSlice = createSlice({
  name: "mantraAdd",
  initialState: {
    isFormOpen: false,
  },
  reducers: {
    toogleForm: (state) => {
      state.isFormOpen = !state.isFormOpen;
    },
  },
});

export const { toogleForm } = mantraAddSlice.actions;
export default mantraAddSlice.reducer;